module["exports"] = [
  "Sr.",
  "Sra.",
  "Sta."
];



/*****************
 ** WEBPACK FOOTER
 ** ./~/faker/lib/locales/es/name/prefix.js
 ** module id = 496
 ** module chunks = 0
 **/